import { SharedData } from './../../routes/apply/apply-models';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, pipe } from 'rxjs';
import { CacheService } from './cache.service';
import { switchMap, tap } from 'rxjs/operators';
import { UtilsService } from './utils.service';
import { AuthService } from 'app/routes/sessions/login/auth.service';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})

/**
 * many of our constants come from the backend via this service. This helps us keep the frontend and backend
 * in sync.
 */
export class StaticDataRemoteService {

  staticData: SharedData = null;

  demoBankWeRemove = "Demo Bank";
  demoBCOWeDontRemoveFor1 = "demotradefinancecompany1@gmail.com";
  demoBCOWeDontRemoveFor2 = "demotradefinancecompany2@gmail.com";

  constructor(
    private http: HttpClient, 
    private cache: CacheService, 
    private utils:UtilsService,
    private authService:AuthService) { }

  getStaticData(): Observable<SharedData> {
    if (this.staticData !== null) {
      return of(this.staticData);
    } else {
      return this.cache.get('remoteStaticData')
        .pipe(
          switchMap(data => {
            if (data) {
              return of(data);
            } else {
              return this.getStaticDataRemote();
            }
          }));
    }
  }

  private getStaticDataRemote(): Observable<object> {
    const url = environment.rootUrl + environment.urls.shared_data;
    return this.http.get<object>(url)
      .pipe(
        tap((data:SharedData) => {
          // if this is prod, and we are a demo user, keep demo bank in, otherwise remove it.
          if (this.utils.isProd() || true) {
            const user = this.authService.currentUserValue;
            if (user && (user.user_email_id !== this.demoBCOWeDontRemoveFor1 && user.user_email_id !== this.demoBCOWeDontRemoveFor2)) {
              for (let i = 0; i < data.supportedBanks.length; i++) {
                const bank = data.supportedBanks[i];
                if (bank.full_name === this.demoBankWeRemove) {
                  data.supportedBanks.splice(i, 1);
                  break;
                }
              }
            } else {
              console.log("getStaticDataRemote; for this user, we don't hide the bank!");
            }
          }
          this.cache.set('remoteStaticData', data, 6000);
          // console.log('saving remoteStaticData', data);
        }));
  }
}
